import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { store } from "../../../components/VerticalLayout/store";
import { setModify } from "./store";
import { MainColorTabsWrapper } from "@components/Common/MainColorTabsWrapper";
import { getPathAuthorization } from "@components/VerticalLayout";
import MessageInfo from "@components/Common/MessageInfo";
import PageTitle from "@components/Common/PageTitle";
import { Languages } from "./Languages";
import { LanguagesShop } from "./LanguagesShop";
import { StyledTabs } from "./StyledTabs";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

function LocalTabsLanguage() {
    const [
        isArchivedLanguagesClicked,
        setIsArchivedLanguagesClicked,
    ] = React.useState(false);
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(store);
    const [limit, setLimit] = React.useState<number>(1);
    const location = useLocation();
    const { profileAuthorization, selectedAccount } = useSelector(
        (state: any) => ({
            profileAuthorization: state.global.infoUser.profileAuthorization,
            selectedAccount: state.global.selectedAccount,
        })
    );
    setModify(
        getPathAuthorization(location.pathname, profileAuthorization).Modifie
    );

    const LangueShop = (
        <Languages
            setIsArchivedLanguagesClicked={setIsArchivedLanguagesClicked}
            isArchivedLanguagesClicked={isArchivedLanguagesClicked}
            setLimit={setLimit}
        />
    );

    const LangueFranchise = (
        <StyledTabs
            tabs={[
                {
                    content: (
                        <Languages
                            setIsArchivedLanguagesClicked={
                                setIsArchivedLanguagesClicked
                            }
                            isArchivedLanguagesClicked={
                                isArchivedLanguagesClicked
                            }
                            setLimit={setLimit}
                        />
                    ),
                    disabled: false,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark cmn_btn_franchise"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Language")}
                        </div>
                    ),
                },
                {
                    content: (
                        <LanguagesShop
                            setIsArchivedLanguagesClicked={
                                setIsArchivedLanguagesClicked
                            }
                            isArchivedLanguagesClicked={
                                isArchivedLanguagesClicked
                            }
                            setLimit={setLimit}
                        />
                    ),
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark border-0 cmn_btn_boutique"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Shop language")}
                        </div>
                    ),
                },
            ]}
        />
    );

    const breadcrumbItems = useMemo(
        () => [
            {
                item: t("Settings").toUpperCase(),
                link: process.env.REACT_APP_PORTAIL_URL || "#",
            },
            {
                item: selectedAccount?.toUpperCase() || "",
                link: oneShop ? "/setting/customer-account" : "/compte",
            },
            {
                item: t("General settings").toUpperCase(),
                link: "#",
            },
            {
                item: (!isArchivedLanguagesClicked
                    ? t("Language")
                    : t("Archived languages")
                ).toUpperCase(),
                link: "#",
            },
        ],
        [t, selectedAccount, oneShop, isArchivedLanguagesClicked]
    );

    return (
        <React.Fragment>
            <ToastContainer limit={limit} />
            <PageTitle title={t("General settings")} />
            <div className="page-content__clz">
                <div className="lan_txt_language">
                    <StyledBreadcrumb items={breadcrumbItems} />
                </div>

                <MessageInfo
                    message={t(
                        "The languages used are configured in this section."
                    )}
                />

                <MainColorTabsWrapper>
                    {oneShop ? LangueShop : LangueFranchise}
                </MainColorTabsWrapper>
            </div>
        </React.Fragment>
    );
}
export const TabsLanguage = React.memo(LocalTabsLanguage);
